// removed by extract-text-webpack-plugin
module.exports = {"toolbar":"antd-pro_-_-scaffold-src-components-FooterToolbar-toolbar","left":"antd-pro_-_-scaffold-src-components-FooterToolbar-left","right":"antd-pro_-_-scaffold-src-components-FooterToolbar-right"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/FooterToolbar/index.less
// module id = 433
// module chunks = 0 1